import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../auth';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import Swal from 'sweetalert2';
import { axiosAuth } from '../../../api';
import { useLocation } from 'react-router-dom';
import { FaCalendar, FaCircleXmark } from 'react-icons/fa6';
import { FaCheckCircle } from 'react-icons/fa';
import { BsBarChartLineFill } from 'react-icons/bs';
import { RiMoneyDollarCircleFill } from 'react-icons/ri';
import { PiChartLineFill } from 'react-icons/pi';

function UserInformationProgress({ id, accessToken, userInformation, selectedDate, averageLead }) {

    const location = useLocation();
    const { theme } = useContext(ThemeContext);
    const isMobile = useMediaQuery({ maxWidth: 768 });

    const formatCurrency = (amount) => {
        if (amount < 1000000000) {
            return (amount / 1000000).toFixed(1) + ' M';
        } else {

            return (amount / 1000000000).toFixed() + ' B';
        }
    };

    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');

    const showingDefault = `${year}-${month}`;

    const maxDate = `${year}-${month}`;

    const [monthlyLeadAmount, setMonthlyLeadAmount] = useState();

    const retrieveLeadMonthly = () => {

        axiosAuth.get(

            location.pathname.startsWith('/dashboard-spv') ?
                `/api/analytics/monthly/amount?month=${month}&year=${year}` :
                `/api/analytics/monthly/amount?userId=${id}&month=${month}&year=${year}`
            ,

            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setMonthlyLeadAmount(res.data.data.totalAmountMonthly);

            }).catch(err => {
                console.error(err);

                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: 'Failed to collect data, try again later!',
                });


            })
    };

    useEffect(() => {
        if (accessToken !== undefined && id !== undefined) retrieveLeadMonthly();
    }, [accessToken, id]);

    useEffect(() => {
        const fetchMonthlyLead = async () => {
            if (!selectedDate) return;

            const [year, month] = selectedDate.split("-");

            const monthWithoutLeadingZero = parseInt(month, 10);

            try {
                const response = await axiosAuth.get(
                    location.pathname.startsWith('/dashboard-spv') ?
                        `/api/analytics/monthly/amount?month=${monthWithoutLeadingZero}&year=${year}` :
                        `/api/analytics/monthly/amount?userId=${id}&month=${monthWithoutLeadingZero}&year=${year}`
                    ,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json',
                            withCredentials: true,
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                setMonthlyLeadAmount(response.data.data.totalAmountMonthly);

            } catch (err) {
                console.error(err);
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: 'Failed to collect data, try again later!',
                });
            }
        };

        fetchMonthlyLead();
    }, [selectedDate]);

    const formattedLeadAmountMonthly = formatCurrency(monthlyLeadAmount || 0);
    const formattedLeadAmountQuarterly = formatCurrency(userInformation?.totalAmountQuarterly || 0);

    const formatMonthName = (value) => {
        if (!value) return '';
        const date = new Date(`${value}-01`);
        return date.toLocaleString('id-ID', { month: 'long', year: 'numeric' });
    };

    return (
        <>
            <Row className="d-flex align-items-stretch">
                <Col xs={12} lg={6} className='mb-4'>
                    <Card style={{
                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                        borderRadius: '10px',
                        height: '100%'
                    }}>
                        <Card.Body>
                            <div
                                className='icon-box'
                                style={{
                                    background: theme === 'light' ? '#12B3ED' : '#eadcfd'
                                }}
                            >
                                <span className='pb-1'>
                                    <FaCalendar size={20} color={theme === 'light' ? '#121212' : '#680ED9'} />
                                </span>
                            </div>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '20px',
                                    fontFamily: 'Poppins-Bold',
                                    fontSize: '35px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}
                            >
                                {userInformation?.totalLeadYearly || 0}
                            </p>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: isMobile ? '20px' : '0px',
                                    marginTop: '0px',
                                    fontFamily: 'Poppins-Light',
                                    fontSize: '15px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}>
                                Annual Leads
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} lg={6} className='mb-4'>
                    <Card style={{
                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                        borderRadius: '10px',
                        height: '100%'
                    }}>
                        <Card.Body>
                            <div
                                className='icon-box'
                                style={{
                                    background: theme === 'light' ? '#12B3ED' : '#C9EBFF'
                                }}
                            >
                                <span>
                                    <FaCheckCircle size={25} color={theme === 'light' ? '#121212' : '#159FF0'} />
                                </span>
                            </div>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '20px',
                                    fontFamily: 'Poppins-Bold',
                                    fontSize: '35px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}
                            >
                                {userInformation?.totalSuccessLeadYearly || 0}
                            </p>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: isMobile ? '20px' : '0px',
                                    marginTop: '0px',
                                    fontFamily: 'Poppins-Light',
                                    fontSize: '15px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}
                            >
                                Annual Success Leads
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} lg={6} className='mb-4'>
                    <Card style={{
                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                        borderRadius: '10px',
                        height: '100%'
                    }}>
                        <Card.Body>
                            <div
                                className='icon-box'
                                style={{
                                    background: theme === 'light' ? '#12B3ED' : '#FFC6D8'
                                }}
                            >
                                <span>
                                    <FaCircleXmark size={25} color={theme === 'light' ? '#121212' : '#FF5288'} />
                                </span>
                            </div>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '20px',
                                    fontFamily: 'Poppins-Bold',
                                    fontSize: '35px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}
                            >
                                {userInformation?.totalFailLeadYearly || 0}
                            </p>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: isMobile ? '20px' : '0px',
                                    marginTop: '0px',
                                    fontFamily: 'Poppins-Light',
                                    fontSize: '15px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}
                            >
                                Annual Unsuccess Leads
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} lg={6} className='mb-4'>
                    <Card style={{
                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                        borderRadius: '10px',
                        height: '100%'
                    }}>
                        <Card.Body>
                            <div
                                className='icon-box'
                                style={{
                                    background: theme === 'light' ? '#12B3ED' : '#FFD8C1'
                                }}
                            >
                                <span>
                                    <BsBarChartLineFill size={25} color={theme === 'light' ? '#121212' : '#FD8540'} />
                                </span>
                            </div>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '20px',
                                    fontFamily: 'Poppins-Bold',
                                    fontSize: '35px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}
                            >
                                {formattedLeadAmountQuarterly}
                            </p>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: isMobile ? '20px' : '0px',
                                    marginTop: '0px',
                                    fontFamily: 'Poppins-Light',
                                    fontSize: '15px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}
                            >
                                Quarter Amount
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} lg={6}>
                    <Card style={{
                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                        borderRadius: '10px',
                        height: '100%'
                    }}>
                        <Card.Body>
                            <Row>
                                <Col xs={8} className='text-start'>
                                    <div
                                        className='icon-box'
                                        style={{
                                            background: theme === 'light' ? '#12B3ED' : '#CAF7DF'
                                        }}
                                    >
                                        <span>
                                            <RiMoneyDollarCircleFill size={25} color={theme === 'light' ? '#121212' : '#22df7aff'} />
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '20px',
                                    fontFamily: 'Poppins-Bold',
                                    fontSize: '35px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}
                            >
                                {formattedLeadAmountMonthly}
                            </p>
                            <span className='ps-2' style={{ color: theme === 'light' ? '#c5c5c5ff' : '#c5c5c5ff', fontSize: '16px', fontWeight: 500, fontFamily: 'Poppins-Light' }}>
                                {formatMonthName(!selectedDate ? showingDefault : selectedDate)}
                            </span>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: isMobile ? '20px' : '0px',
                                    marginTop: '0px',
                                    fontFamily: 'Poppins-Light',
                                    fontSize: '15px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}
                            >
                                Monthly Amount
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs={12} lg={6}>
                    <Card style={{
                        backgroundColor: theme === 'light' ? '#282828' : '#FFFFFF',
                        borderRadius: '10px',
                        height: '100%'
                    }}>
                        <Card.Body>
                            <div
                                className='icon-box'
                                style={{
                                    background: theme === 'light' ? '#12B3ED' : '#D5FFFC'
                                }}
                            >
                                <span>
                                    <PiChartLineFill size={27} color={theme === 'light' ? '#121212' : '#2ad3c8ff'} />
                                </span>
                            </div>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: '0px',
                                    marginTop: '20px',
                                    fontFamily: 'Poppins-Bold',
                                    fontSize: '35px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}
                            >
                                {averageLead + '%' || '0%'}
                            </p>
                            <p
                                className='text-start ps-2'
                                style={{
                                    marginBottom: isMobile ? '20px' : '0px',
                                    marginTop: '0px',
                                    fontFamily: 'Poppins-Light',
                                    fontSize: '15px',
                                    color: theme === 'light' ? '#FFFFFF' : '#222'
                                }}
                            >
                                Average Lead Progress
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>

    )
}

export default UserInformationProgress
